import { CTA, ProductTopic } from "./types";
import InvestmentPlan from "@modules/tasks/assets/investment-plan.svg";
import FinancialPlan from "@modules/tasks/assets/financial-plan.svg";
import TaxPlan from "@modules/tasks/assets/tax-plan.svg";
import InsurancePlan from "@modules/tasks/assets/insurance-plan.svg";
import TrustPlan from "@modules/tasks/assets/trust-plan.svg";
import DebtAndCashManagement from "@modules/tasks/assets/debt-and-cash-management.svg";
import CareerManagement from "@modules/tasks/assets/career-management.svg";
import CombinedPhaseTwo from "@modules/tasks/assets/combined.svg";
import { capitalize, replace } from "lodash";

const getCTADisplayName = (action: string, ctaText?: string | null) => {
  switch (action) {
    case CTA.DOCUSIGN_WMA:
    case CTA.DOCUSIGN_WDA:
    case CTA.DOCUSIGN_WMA_COCLIENT:
    case CTA.DOCUSIGN_WDA_COCLIENT:
      return "Sign Agreement";
    case CTA.SCHEDULE_MEETING_ADVISOR:
      return "Schedule Meeting";
    case CTA.CONNECT_INVESTMENT_ACCOUNT:
      return "Connect Accounts";
    case CTA.UPLOAD_CREDENTIALING_DOCUMENTS:
    case CTA.UPLOAD_INVESTMENT_DOCUMENTS:
    case CTA.UPLOAD_INSURANCE_DOCUMENTS:
    case CTA.UPLOAD_TRUST_ESTATE_DOCUMENTS:
    case CTA.UPLOAD_BANKING_DOCUMENTS:
    case CTA.UPLOAD_TAX_DOCUMENTS:
    case CTA.UPLOAD_GENERAL_DOCUMENTS:
    case CTA.UPLOAD_INCOME_DOCUMENTS:
    case CTA.UPLOAD_REAL_ESTATE_DOCUMENTS:
      return "Upload Documents";
    case CTA.UPLOAD_TAX_CENTER_DOCUMENT:
      return "Upload Tax Document";
    case CTA.DOWNLOAD_PDF:
      return "Download PDF";
    case CTA.CLIENT_INTAKE_FORM:
    case CTA.OPEN_WIZARD:
      return "Update Information";
    case CTA.NAVIGATE_TO_TAX_CENTER:
      return "Complete Taxes";
    case CTA.OPEN_URL:
      return ctaText || "Open URL";
    default:
      return capitalize(replace(action, "_", " "));
  }
};

const defaultCTA = CTA.OPEN_URL;
const getOpenURLModalLabel = (action: CTA) => {
  switch (action) {
    case CTA.SCHEDULE_MEETING_ADVISOR:
      return "Enter Calendly URL";
    case CTA.OPEN_URL:
      return "Enter the URL for Trust & Will";
    default:
      return "Enter the URL for Trust & Will";
  }
};

const getTopicIcon = (topic?: ProductTopic) => {
  switch (topic) {
    case ProductTopic.FINANCIAL_PLAN:
      return FinancialPlan;
    case ProductTopic.INVESTMENT_PLAN:
      return InvestmentPlan;
    case ProductTopic.TAX_PLAN:
      return TaxPlan;
    case ProductTopic.INSURANCE_PLAN:
      return InsurancePlan;
    case ProductTopic.ESTATE_PLAN:
      return TrustPlan;
    case ProductTopic.DEBT_AND_CASH:
      return DebtAndCashManagement;
    case ProductTopic.CAREER:
      return CareerManagement;
    default:
      return CombinedPhaseTwo;
  }
};

export { getCTADisplayName, getTopicIcon, getOpenURLModalLabel, defaultCTA };
